import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Container from '../Container';

const defaultProps = {
  h: null,
  v: null,
  left: null,
  right: null,
  top: null,
  bottom: null,
  className: '',
  children: null,
};

const propTypes = {
  h: PropTypes.number,
  v: PropTypes.number,
  left: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  right: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  top: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  bottom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  children: PropTypes.node,
};

const Spacing = ({
  h,
  v,
  left,
  right,
  top,
  bottom,
  className,
  children,
}) => (
  <Container
    className={classnames(
      h && `mx-${h}`,
      v && `my-${v}`,
      left && `ml-${left}`,
      right && `mr-${right}`,
      top && `mt-${top}`,
      bottom && `mb-${bottom}`,
      className,
    )}
  >
    {children}
  </Container>
);

Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;

export default Spacing;
